<template>
  <div class="label__emit--wrap" :class="disabled ? 'disabled' : ''">
    <div
      class="drop-zone"
      @dragover.prevent="handleDragOver"
      @dragleave.prevent="handleDragLeave"
      @drop.prevent="handleDrop"
      :class="{ 'drag-over': isDragOver }"
    >
      <label class="label__emit--button gray">
        <span>Choisir</span>
        <input
          type="file"
          hidden
          :disabled="isApproved"
          enctype="multipart/form-data"
          @change="handleFileChange"
          :id="id"
          :accept="allowedFileExtensions"
          multiple
        />
      </label>
      <div class="drop-zone__prompt" v-if="fileExist">
        {{ file.map((f) => f.name).join(", ") }}
      </div>
      <div class="drop-zone__prompt" v-else>
        Glisser et déposer des fichiers
      </div>
    </div>
    <div v-if="fileExist" class="portlet__head--button-group col-3">
      <button
        v-if="!isBusy"
        class="orange-button"
        :disabled="!validFileUpload"
        @click="uploadDocument()"
      >
        <span>Ajouter</span>
      </button>
      <button v-else class="orange-button" disabled="true">
        <span>Uploading</span>
      </button>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  props: {
    value: File,
    options: Object,
    disabled: Boolean,
    allowedFileExtensions: {
      type: String,
      default: "image/jpeg, image/jpg, image/png, image/gif, application/pdf",
    },
    isApproved: Boolean,
    currentDocType: {
      type: String,
      default: "",
    },
    clientID: Number,
  },
  data() {
    return {
      file: [],
      type: "",
      isBusy: false,
      afterUploaded: false,
      isDragOver: false, // Track drag-over state
    };
  },
  mixins: [validationMixin],
  methods: {
    handleFileChange(e) {
      const files = Array.from(e.target.files);
      this.$emit("input", files);
      this.file = files;
      this.type = files.map((file) => file.type);
      this.afterUploaded = false;
    },
    uploadDocument() {
      if (!this.file || this.file.length === 0) {
        this.showWarningNotification("Please select at least one file");
        return;
      }

      this.isBusy = true;
      const url = "verification_documents/create_client";
      const data = {
        // files: this.file,
        file: this.file,
        type: this.type.join(", "),
        document_type: this.currentDocType,
        client_id: this.clientID,
      };

      this.apiMultiFile(url, data)
        .then((response) => {
          this.afterUploaded = true;
          this.showSuccessNotification(
            "Vos documents ont été uploadés avec succès."
          );
          this.$emit("verification_documents_uploaded", {
            verification_documents: response.data.verification_documents,
          });
          this.clearFields();
          this.isBusy = false;
        })
        .catch((error) => {
          this.showErrorNotification(error);
          this.isBusy = false;
        });
    },
    clearFields() {
      this.file = [];
      this.$emit("input", []);
      this.type = "";
      this.options.currentFile = false;
      this.options.hash = null;
      this.options.name = "Choisir un document";
      this.options.placeholder = true;
    },
    openPreviewDocument() {
      this.isBusy = true;
      let url = "verification_documents/file-preview";
      this.apiGet(url, {
        hash: this.options.hash,
        type: this.options.type,
      })
        .then((response) => {
          this.isBusy = false;
          console.log(response);
          if (response.data && response.data.url) {
            window.open(response.data.url);
          }
        })
        .catch((error) => {
          this.isBusy = false;
          this.showErrorNotification(error);
        });
    },
    handleDragOver() {
      this.isDragOver = true;
    },
    handleDragLeave() {
      this.isDragOver = false;
    },
    handleDrop(e) {
      this.isDragOver = false;
      const files = e.dataTransfer.files;
      if (files.length) {
        const selectedFiles = Array.from(files);
        const validFiles = this.filterValidFiles(selectedFiles);
        if (validFiles.length < selectedFiles.length) {
          this.showWarningNotification("Allowed extension: .jpg, .png, .pdf.");
        }
        this.file = validFiles;
        this.$emit("input", this.file);
      }
    },
    filterValidFiles(file) {
      const allowedExtensions = this.allowedFileExtensions.split(',').map(ext => ext.trim());
      return file.filter(f => {
        const fileExtension = f.type; // Get the MIME type
        if (!allowedExtensions.includes(fileExtension)) {
          return false; // Exclude invalid file
        }
        return true; // Include valid file
      });
    },
  },
  computed: {
    fileExist() {
      return this.file.length > 0;
    },
    validFileUpload() {
      return this.file.length > 0;
    },
  },
  validations: {
    file: {
      required,
    },
  },
};
</script>
<style scoped>
.drop-zone {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s ease;
}

.drop-zone.drag-over {
  border-color: #42b983;
}

.drop-zone__prompt {
  margin-top: 10px;
  color: #666;
}

.label__emit--wrap.disabled .drop-zone {
  opacity: 0.6;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Clients/Documents/MultiFileInput.vue